import { List, useDataGrid } from "@refinedev/mui";
import React from "react";

import { IPrefer } from "./interfaces";
import { SearchToolbar, DataGridPanel, ListPageHeader } from "components/list";
import { preferColumns } from "./components/preferColumns";
import { preferSearchFields } from "./components/preferSearchFields";

export const PreferList: React.FC = () => {
    const { dataGridProps, setFilters, filters, tableQueryResult } =
        useDataGrid<IPrefer>({
            initialCurrent: 1,
            initialPageSize: 20,
            sorters: {
                initial: [{ field: "id", order: "desc" }],
            },
        });

    // refine의 rowCount는 fetch 중 잠깐 0으로 떨어져 "전체 0건"이 깜빡인다.
    const lastRowCountRef = React.useRef<number | undefined>(undefined);
    if (!dataGridProps.loading && typeof dataGridProps.rowCount === "number") {
        lastRowCountRef.current = dataGridProps.rowCount;
    }

    return (
        <List breadcrumb={<></>}>
            <ListPageHeader
                count={lastRowCountRef.current}
                description="학부모별 관심 시설 목록"
            />

            <SearchToolbar
                fields={preferSearchFields}
                filters={filters}
                setFilters={setFilters}
            />

            <DataGridPanel
                {...dataGridProps}
                columns={preferColumns}
                isError={tableQueryResult.isError}
                errorMessage="관심 시설 목록을 불러오지 못했습니다."
                emptyMessage="조건에 맞는 관심 시설이 없습니다."
                pageSizeOptions={[10, 20, 30, 50, 100]}
                disableColumnFilter
                filterModel={undefined}
            />
        </List>
    );
};
